import { BsExclamationTriangle } from 'react-icons/bs';

import AppBanner from '#globalComponents/AppBanner/AppBanner';
import { useBillingStatus } from '#settingsFeature/hooks/useBillingStatus';
import { useCreatePortalSession } from '#settingsFeature/models/billing/mutations';

/**
 * Full-width banner shown when a payment has failed (past_due / unpaid / incomplete).
 * Generic across all paid features. CTA opens the Stripe Customer Portal to update
 * the payment method — the single customer-level place to fix billing. Not dismissable.
 */
const PaymentRecoveryBanner = () => {
	const { needsPaymentUpdate } = useBillingStatus();
	const createPortal = useCreatePortalSession();

	if (!needsPaymentUpdate) return null;

	const handleUpdate = async () => {
		try {
			const { data } = await createPortal.mutateAsync();
			if (data?.url) window.location.href = data.url;
		} catch {
			// Global mutation error handling surfaces the toast.
		}
	};

	return (
		<AppBanner
			tone="warning"
			icon={BsExclamationTriangle}
			action={{
				label: 'Zahlungsmethode aktualisieren',
				onClick: handleUpdate,
				loading: createPortal.isPending,
			}}
		>
			Ihre letzte Zahlung ist <strong>fehlgeschlagen</strong>. Bitte aktualisieren Sie Ihre Zahlungsmethode, um
			Ihren Zugang zu behalten.
		</AppBanner>
	);
};

export default PaymentRecoveryBanner;
